// RightSidebar.js

import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faBell, faUsers, faChartBar, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const RightSidebar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    // Initial check on component mount
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const sidebarStyle = {
    backgroundColor: "#333",
    color: "#fff",
    height: "100vh",
    width: isMobile ? (sidebarOpen ? "250px" : "0") : "250px",
    position: "fixed",
    top: "0",
    right: isMobile ? (sidebarOpen ? "0" : "-250px") : "0",
    paddingTop: "60px",
    transition: "width 0.3s, right 0.3s",
    overflowX: "hidden",
  };

  const headerStyle = {
    textAlign: "center",
    padding: "20px",
  };

  const navStyle = {
    listStyle: "none",
    padding: "0",
    margin: "0",
  };

  const itemStyle = {
    marginBottom: "10px",
  };

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#fff",
    padding: "10px",
    transition: "background-color 0.3s",
  };

  const linkHoverStyle = {
    backgroundColor: "#555",
  };

  const iconTextStyle = {
    marginLeft: "10px",
  };

  return (
    <div style={sidebarStyle}>
      {isMobile && (
        <div style={{ textAlign: "right", marginRight: "10px", marginBottom: "10px" }}>
          <FontAwesomeIcon icon={sidebarOpen ? faTimes : faBars} onClick={toggleSidebar} style={{ cursor: "pointer", fontSize: "20px" }} />
        </div>
      )}
      <div style={headerStyle}>
        <h3>Right Sidebar</h3>
      </div>
      <ul style={navStyle}>
        <li style={itemStyle}>
          <a href="#" style={linkStyle}>
            <FontAwesomeIcon icon={faCog} />
            <span style={iconTextStyle}>Settings</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a href="#" style={linkStyle}>
            <FontAwesomeIcon icon={faBell} />
            <span style={iconTextStyle}>Notifications</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a href="#" style={linkStyle}>
            <FontAwesomeIcon icon={faUsers} />
            <span style={iconTextStyle}>Users</span>
          </a>
        </li>
        <li style={itemStyle}>
          <a href="#" style={linkStyle}>
            <FontAwesomeIcon icon={faChartBar} />
            <span style={iconTextStyle}>Analytics</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default RightSidebar;
